module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-upload"
  }, [_c('div', {
    staticClass: "bk-form"
  }, [_c('worksPictures', {
    attrs: {
      "is-edited": true,
      "logo-img": _vm.logoImg,
      "cover-img": _vm.coverImg,
      "preview-img": _vm.previewImg
    },
    on: {
      "upPictureId": _vm.allPictureIds,
      "removePicture": _vm.removePicture
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-action"
  }, [_c('a', {
    class: ['bk-button', 'bk-primary', {
      'is-loading': _vm.saveFlag === false
    }],
    attrs: {
      "id": "submit",
      "title": "提交"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v("提交")])]), _vm._v(" "), _c('a', {
    staticClass: "bk-button bk-return",
    attrs: {
      "title": "返回"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('span', [_vm._v("返回")])])])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-1ea28e27!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/works/basic_works_pictures.vue
// module id = hCEo
// module chunks = 16